import { render } from "./EventDetail.vue?vue&type=template&id=61340858&ts=true"
import script from "./EventDetail.vue?vue&type=script&lang=ts"
export * from "./EventDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__